import { TbReportMoney } from 'react-icons/tb'

import { Hint } from '@/Ship/Components/Hint'

import { LogisticiansFinancialTable } from '../Components/LogisticiansFinancialTable'
import { ReportFrame } from '../Components/ReportFrame'
import { logisticiansFinancialReportStore } from '../Stores/ReportStore'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/** «Звіт по логістам - фінансовий» (`SPEC-027` §2.1, §4.2). */
const LogisticiansFinancialPage = () => (
    <ReportFrame
        reportKey="Report.LogisticiansFinancial"
        store={logisticiansFinancialReportStore}
        hint={
            <Hint id="report.financial.table">
                Рахуються непрограні заявки з датою розвантаження в періоді, за відповідальним логістом; відсоток —
                частка в прибутку всіх таких заявок компанії. Адміністратор бачить усіх логістів, решта — лише свій
                рядок.
            </Hint>
        }
        isEmpty={(report) => report.rows.length === 0}
    >
        {(report) => <LogisticiansFinancialTable report={report} />}
    </ReportFrame>
)

export default LogisticiansFinancialPage

export const pageConfig: IPageConfig = {
    key: 'Report.LogisticiansFinancial',
    route: '/report/logisticians-financial',
    title: 'Звіт по логістам - фінансовий',
    icon: <TbReportMoney />,
}
